import { getGitHubIcon } from "Agile/Scripts/Card/Annotations/GitHubLinksAnnotation/Icons";
import { AnnotationBadge, IAnnotationBadgeOptions } from "Agile/Scripts/Card/CardsAnnotationsCommon";
import { ExternalArtifactType } from "TFS/WorkItemTracking/DataProviderContracts";
import { ILinkedArtifact } from "TFS/WorkItemTracking/ExtensionContracts";
import { RichContentTooltip } from "VSS/Controls/PopupContent";
import { Debug } from "VSS/Diag";

export interface IGitHubLinksAnnotationBadgeOptions extends IAnnotationBadgeOptions {}

export class GitHubLinksAnnotationBadge extends AnnotationBadge {
    private _$summaryText: JQuery;
    private _summaryTooltip: RichContentTooltip;

    constructor(options: IGitHubLinksAnnotationBadgeOptions) {
        super({ cssClass: "github-links-badge", ...options });
    }

    /**
     * Intializes annotation with provided options
     */
    public initializeOptions(options?: IGitHubLinksAnnotationBadgeOptions): void {
        super.initializeOptions({ $annotationIcon: getGitHubIcon(), ...options });
    }

    /**
     * Refreshes the badge control with updated data.
     */
    public update(source: ILinkedArtifact[]): void {
        super.update(source);
        this._updateSummary(source);
    }

    public createLayout(): void {
        super.createLayout();
        this._$summaryText = $("<span/>").addClass("summary-text");
        this.$container[0].appendChild(this._$summaryText[0]);
    }

    public dispose(): void {
        super.dispose();

        if (this._options.$annotationIcon) {
            this._options.$annotationIcon = null;
        }

        if (this._summaryTooltip) {
            this._summaryTooltip.dispose();
            this._summaryTooltip = null;
        }

        if (this._$summaryText) {
            this._$summaryText = null;
        }
    }

    private _updateSummary(items: ILinkedArtifact[]): void {
        Debug.assertIsNotNull(items, "items");

        // Update badge text with total item count
        const totalCount = items.length;
        this._$summaryText.text(totalCount);

        // Generate tooltip per link type and it is order by item type (PR, Commit and Issue).
        const linkItemsByType: { [type: number]: number } = items.reduce((map, item) => {
            const linkItemType = item.externalLinkedArtifactContext.itemType;
            if (!map[linkItemType]) {
                map[linkItemType] = 0;
            }
            map[linkItemType]++;
            return map;
        }, {});

        const linkNamesByType: { [type: number]: string } = items.reduce((map, item) => {
            const linkItemType = item.externalLinkedArtifactContext.itemType;
            if (!map[linkItemType]) {
                map[linkItemType] = item.linkTypeDisplayName;
            }
            return map;
        }, {});

        let $tooltipText = $("<div/>");
        const getItemTooltipByType = (type: ExternalArtifactType): void => {
            if (linkItemsByType[type]) {
                $("<div/>").text(`${linkNamesByType[type]}: ${linkItemsByType[type]}`).appendTo($tooltipText);
            }
        };
        getItemTooltipByType(ExternalArtifactType.PullRequest);
        getItemTooltipByType(ExternalArtifactType.Commit);
        getItemTooltipByType(ExternalArtifactType.Issue);

        if (this._summaryTooltip) {
            this._summaryTooltip.setHtmlContent($tooltipText);
        } else {
            this._summaryTooltip = RichContentTooltip.add($tooltipText, this.$container, { setAriaDescribedBy: true });
        }
    }
}
